import code from './code';
import { codeQuality } from './codeQuality';
import enterprise from './enterprise';
import collaborate from './collaborate';
import trackAndSupport, { trackAndSupportWithoutJWM } from './trackAndSupport';
import apps from './apps';
import training from './training';
import { securityAndIdentityWithGuard } from './securityAndIdentity';
import discovery from './discovery';

export default [
  trackAndSupport,
  collaborate,
  code,
  codeQuality,
  enterprise,
  apps,
  training,
  discovery,
];

export const getProductCategory = () => {
  const categories = [
    trackAndSupportWithoutJWM,
    collaborate,
    code,
    codeQuality,
    securityAndIdentityWithGuard,
    enterprise,
    apps,
    training,
    discovery,
  ];

  return categories;
};
